module.exports = __webpack_public_path__ + "static/media/country_th.af5c05ca.webp";